var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.19602 11.2298C7.29646 11.3234 7.37702 11.4362 7.43289 11.5616C7.48877 11.687 7.51881 11.8224 7.52123 11.9597C7.52365 12.0969 7.4984 12.2333 7.44699 12.3606C7.39557 12.4879 7.31904 12.6035 7.22197 12.7006C7.12489 12.7977 7.00926 12.8742 6.88197 12.9256C6.75468 12.977 6.61833 13.0023 6.48107 12.9998C6.3438 12.9974 6.20843 12.9674 6.08303 12.9115C5.95763 12.8556 5.84477 12.7751 5.75118 12.6746L0.298972 7.22242C0.10753 7.03074 0 6.77091 0 6.5C0 6.22909 0.10753 5.96926 0.298972 5.77758L5.75118 0.32537C5.84477 0.224931 5.95763 0.144372 6.08303 0.0884972C6.20843 0.0326233 6.3438 0.00258064 6.48107 0.00015831C6.61833 -0.00226307 6.75468 0.0229855 6.88197 0.0744009C7.00926 0.125817 7.12489 0.202346 7.22197 0.29942C7.31904 0.396496 7.39557 0.512129 7.44699 0.639422C7.4984 0.766715 7.52365 0.903058 7.52123 1.04032C7.51881 1.17758 7.48877 1.31295 7.43289 1.43835C7.37702 1.56376 7.29646 1.67662 7.19602 1.77021L3.48852 5.47771L16.6965 5.47771C16.9676 5.47771 17.2276 5.58542 17.4194 5.77713C17.6111 5.96885 17.7188 6.22887 17.7188 6.5C17.7188 6.77113 17.6111 7.03115 17.4194 7.22287C17.2276 7.41458 16.9676 7.52229 16.6965 7.52229L3.48852 7.52229L7.19602 11.2298Z",
    fill: "#6F6F6F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGrey);
export default __webpack_public_path__ + "static/media/back-grey.93d2066b3ab3aeec3c18536d8660c439.svg";
export { ForwardRef as ReactComponent };